const Institutions = () => import("./views/Institutions.vue");
const InstitutionEdit = () => import("./views/InstitutionEdit.vue");

const route = "/institutions";

export default [
  {
    path: route,

    name: "institutions.list",
    component: Institutions,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${route}/create`,
    name: "institutions.create",
    component: InstitutionEdit,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/:institutionId/edit`,
    name: "institutions.edit",
    component: InstitutionEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];
